import { SET_IS_OPEN_ASSIGN_PRODUCT_MODAL } from '../actionTypes';
import { installersActions } from '../reducer';

export default (value) =>
    installersActions[SET_IS_OPEN_ASSIGN_PRODUCT_MODAL](value);
